export default __webpack_public_path__ + "static/preloading-b8a5f49c033842e692df7ae45ce1b2fc.gif";